import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack, Typography } from '@mui/material';
import { transientOptions } from 'utils/transientOptions';

export const BoxContent = styled(Stack)`
  margin: 4px !important;
  border-radius: 8px;
  box-shadow: 0px 0px 20px 0px #0000001a;
`;

export const LoadingOverlay = styled(Stack)({
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const FaceInAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(0.70);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledImage = styled('img', transientOptions)<{
  isQRcode?: boolean;
}>`
  width: ${({ isQRcode }) => (!isQRcode ? '100%' : '105px')};
  height: ${({ isQRcode }) => (!isQRcode ? '100%' : '105px')};
  animation: ${FaceInAnimation} 0.7s ease-in-out;
`;

export const StyledTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.05px;
`;

export const StyledText = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.05px;
  color: #686868;
`;
